import { LegalPage } from "@/pages/Privacy";

export default function TermsPage() {
  return <LegalPage kind="terms" />;
}
